module.exports = __webpack_public_path__ + "img/AAPL.6fc20e26.png";